import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import HeadTitle from 'src/components/atoms/HeadTitle'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { NoLineBreak } from 'src/components/atoms/NoLineBreak'
import PaperCard from 'src/components/molecules/PaperCard'

const whitePapers = [
  {
    thumbnailName: 'commmuneOnlineCustomer',
    subtitle:
      'オンライン顧客接点\nうちもやらなきゃ！を考えた担当者がまず読む本',
    linkTo: '/whitepapers/commmune_onlinecustomer_WP'
  },
  {
    thumbnailName: 'commmuneCommunityMarketing',
    subtitle: 'コミュニティマーケティング超入門',
    linkTo: '/whitepapers/commmune_communitymarketing_WP'
  },
  {
    thumbnailName: 'commmuneCommunityTouch',
    subtitle: 'コミュニティタッチ概論',
    linkTo: '/whitepapers/commmune_community_touch'
  },
  {
    thumbnailName: 'commmuneCustomerSuccess2',
    subtitle: '今後5年の新潮流!「カスタマーサクセス2.0」\n徹底解説',
    linkTo: '/whitepapers/commmune_customersuccess2_WP'
  }
]

export const TopWhitePapers = () => {
  const data = useStaticQuery(graphql`
    query {
      commmuneOnlineCustomer: file(
        relativePath: { eq: "whitepapers/commmune-online-customer.jpg" }
      ) {
        childImageSharp {
          fluid(maxWidth: 475) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      commmuneCommunityMarketing: file(
        relativePath: { eq: "whitepapers/commmune-community-marketing.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 475) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      commmuneCommunityTouch: file(
        relativePath: { eq: "whitepapers/commmune-community-touch.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 475) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      commmuneCustomerSuccess2: file(
        relativePath: { eq: "whitepapers/commmune-customer-success2.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 475) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Container>
      <HeadTitle as="h2" css={headTitleCss}>
        <NoLineBreak>カスタマーサクセス、</NoLineBreak>
        <NoLineBreak>コミュニティ理解に</NoLineBreak>
        <br />
        <NoLineBreak>お役立ちの資料はこちら</NoLineBreak>
      </HeadTitle>
      <ContentsWrapper>
        <Contents>
          {whitePapers.map((paper, i) => {
            const { childImageSharp } = data[paper.thumbnailName]
            const imageFluid = childImageSharp && childImageSharp.fluid
            return <PaperCard {...paper} imageFluid={imageFluid} key={i} />
          })}
        </Contents>
      </ContentsWrapper>
    </Container>
  )
}

const Container = styled.div`
  background-color: ${Styles.color.primary[200]};
  padding: ${Styles.spacing[11]} 0;
  @media screen and (min-width: ${BreakPoint.MOBILE}) {
    padding: ${Styles.spacing[14]} 0;
  }
`

const headTitleCss = css`
  text-align: center;
  max-width: 80%;
  margin: 0 auto ${Styles.spacing[11]};
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    max-width: 85%;
    margin: 0 auto ${Styles.spacing[12]};
  }
`

const Contents = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  @media screen and (min-width: ${BreakPoint.MOBILE}) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (min-width: ${BreakPoint.TABLET}) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media screen and (min-width: ${BreakPoint.LAPTOP}) {
    grid-template-columns: repeat(4, 1fr);
  }
`
